const ROOT = import.meta.env.BASE_URL.replace(/\/$/, "");
const STORAGE_KEY = "monitor_dodf_session";

function paginaAtual() {
  const ativo = document.querySelector("nav .active, .nav .active, header .active");
  const texto = ativo?.textContent?.trim();
  return texto || document.querySelector("h1")?.textContent?.trim() || "Tela atual";
}

function tokenAtual() {
  try {
    const bruto = localStorage.getItem(STORAGE_KEY);
    if (!bruto) return "";
    return String(JSON.parse(bruto)?.access_token || "");
  } catch {
    return "";
  }
}

const componentes = [
  "Tela atual / visão geral",
  "Painel",
  "Cadastro de termos",
  "Cadastro em lote",
  "Importação CSV/TXT",
  "Resultados",
  "Linha do tempo / vida funcional",
  "Filtros e pesquisa",
  "Notificações",
  "Configurações",
  "Login / cadastro de usuário",
  "Navegação / menus",
  "Visual / acessibilidade",
  "Outro",
];

function instalarEstilos() {
  const style = document.createElement("style");
  style.textContent = `
    .sugira-melhorias-btn{position:fixed;right:18px;bottom:18px;z-index:9000;border:1px solid #cbd5e1;background:#fff;color:#1d4ed8;border-radius:999px;padding:8px 12px;font:600 12px/1.2 system-ui;box-shadow:0 4px 18px rgba(15,23,42,.14);cursor:pointer}
    .sugira-melhorias-btn:hover{background:#eff6ff}.sugestao-backdrop{position:fixed;inset:0;z-index:9100;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;padding:18px}
    .sugestao-modal{width:min(520px,100%);background:#fff;border-radius:14px;box-shadow:0 24px 70px rgba(15,23,42,.28);padding:20px;color:#0f172a}
    .sugestao-head{display:flex;align-items:start;justify-content:space-between;gap:12px;margin-bottom:14px}.sugestao-head h2{font-size:18px;margin:0}.sugestao-head p{font-size:13px;color:#64748b;margin:4px 0 0}
    .sugestao-close{border:0;background:transparent;font-size:22px;cursor:pointer;color:#64748b}.sugestao-modal label{display:block;font-size:12px;font-weight:700;margin:12px 0 5px}
    .sugestao-modal select,.sugestao-modal textarea,.sugestao-modal input{width:100%;box-sizing:border-box;border:1px solid #cbd5e1;border-radius:8px;padding:10px;font:14px system-ui;background:#fff}.sugestao-modal textarea{min-height:130px;resize:vertical}
    .sugestao-actions{display:flex;justify-content:flex-end;gap:8px;margin-top:14px}.sugestao-actions button{border-radius:8px;padding:9px 14px;border:1px solid #cbd5e1;background:#fff;cursor:pointer;font-weight:600}.sugestao-actions .enviar{background:#2563eb;color:#fff;border-color:#2563eb}
    .sugestao-status{font-size:12px;margin-top:10px;padding:8px 10px;border-radius:8px;background:#eff6ff;color:#1e40af}.sugestao-status.erro{background:#fef2f2;color:#b91c1c}.sugestoes-admin-btn{position:fixed;right:18px;bottom:58px;z-index:9000;border:0;background:#0f172a;color:#fff;border-radius:999px;padding:8px 12px;font:600 12px/1.2 system-ui;box-shadow:0 4px 18px rgba(15,23,42,.18);cursor:pointer}.sugestao-admin-modal{width:min(900px,100%);max-height:88vh;overflow:auto}.sugestao-admin-toolbar{display:flex;gap:8px;align-items:center;margin:10px 0 14px}.sugestao-admin-list{display:grid;gap:10px}.sugestao-admin-card{border:1px solid #e2e8f0;border-radius:10px;padding:12px}.sugestao-admin-meta{font-size:12px;color:#64748b;margin-bottom:6px}.sugestao-admin-msg{font-size:14px;white-space:pre-wrap;margin:8px 0}.sugestao-admin-edit{display:grid;grid-template-columns:180px 1fr auto;gap:8px;align-items:end}.sugestao-admin-edit label{margin:0}.sugestao-admin-edit textarea{min-height:70px}.sugestao-admin-save{border:1px solid #2563eb;background:#2563eb;color:#fff;border-radius:8px;padding:10px 12px;font-weight:700;cursor:pointer}
    @media(max-width:600px){.sugira-melhorias-btn{right:12px;bottom:76px}.sugestoes-admin-btn{right:12px;bottom:116px}.sugestao-admin-edit{grid-template-columns:1fr}.sugestao-backdrop{align-items:flex-end;padding:0}.sugestao-modal{border-radius:16px 16px 0 0;padding:18px;max-height:88vh;overflow:auto}}
  `;
  document.head.appendChild(style);
}

function abrirModal() {
  const backdrop = document.createElement("div");
  backdrop.className = "sugestao-backdrop";
  const opcoes = componentes.map((c) => `<option value="${c}">${c}</option>`).join("");
  backdrop.innerHTML = `
    <div class="sugestao-modal" role="dialog" aria-modal="true" aria-label="Sugira melhorias">
      <div class="sugestao-head"><div><h2>Sugira melhorias</h2><p>Conte o que podemos melhorar nesta ferramenta.</p></div><button class="sugestao-close" aria-label="Fechar">×</button></div>
      <label>Tela</label><input data-campo="pagina" value="${paginaAtual().replace(/"/g, "&quot;")}" readonly />
      <label>Componente da sugestão</label><select data-campo="componente">${opcoes}</select>
      <label>Sua sugestão</label><textarea data-campo="mensagem" maxlength="5000" placeholder="Descreva a melhoria, dificuldade ou ideia que você gostaria de ver no Monitor Oficial."></textarea>
      <div class="sugestao-status" hidden></div>
      <div class="sugestao-actions"><button data-acao="cancelar">Cancelar</button><button class="enviar" data-acao="enviar">Enviar sugestão</button></div>
    </div>`;
  document.body.appendChild(backdrop);
  const fechar = () => backdrop.remove();
  backdrop.querySelector(".sugestao-close")?.addEventListener("click", fechar);
  backdrop.querySelector('[data-acao="cancelar"]')?.addEventListener("click", fechar);
  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) fechar(); });
  const area = backdrop.querySelector('[data-campo="mensagem"]') as HTMLTextAreaElement;
  area.focus();

  backdrop.querySelector('[data-acao="enviar"]')?.addEventListener("click", async () => {
    const botao = backdrop.querySelector('[data-acao="enviar"]') as HTMLButtonElement;
    const status = backdrop.querySelector(".sugestao-status") as HTMLDivElement;
    const mensagem = area.value.trim();
    const componente = (backdrop.querySelector('[data-campo="componente"]') as HTMLSelectElement).value;
    const pagina = (backdrop.querySelector('[data-campo="pagina"]') as HTMLInputElement).value;
    if (mensagem.length < 3) {
      status.hidden = false; status.className = "sugestao-status erro"; status.textContent = "Escreva um pouco mais sobre a sugestão."; return;
    }
    const token = tokenAtual();
    if (!token) {
      status.hidden = false; status.className = "sugestao-status erro"; status.textContent = "Sua sessão expirou. Entre novamente antes de enviar."; return;
    }
    botao.disabled = true; botao.textContent = "Enviando…";
    try {
      const r = await fetch(`${ROOT}/api/sugestoes`, {method:"POST",headers:{"Content-Type":"application/json","Authorization":`Bearer ${token}`},body:JSON.stringify({pagina,componente,mensagem})});
      const body = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(body?.detail || "Não foi possível registrar a sugestão.");
      status.hidden = false; status.className = "sugestao-status"; status.textContent = "Obrigado! Sua sugestão foi registrada para avaliação.";
      area.value = ""; botao.textContent = "Enviada";
      setTimeout(fechar, 1300);
    } catch (e:any) {
      status.hidden = false; status.className = "sugestao-status erro"; status.textContent = e?.message || "Falha ao enviar sugestão.";
      botao.disabled = false; botao.textContent = "Enviar sugestão";
    }
  });
}


type SugestaoAdmin = {
  id: number;
  usuario_email: string;
  pagina: string;
  componente: string;
  mensagem: string;
  status: string;
  nota_avaliacao?: string;
  criado_em: string;
};

const statusSugestoes = [
  ["nova", "Nova"], ["em_analise", "Em análise"], ["aprovada", "Aprovada"],
  ["planejada", "Planejada"], ["implementada", "Implementada"], ["descartada", "Descartada"],
] as const;

function opcoesStatus(valor: string) {
  return statusSugestoes.map(([v, r]) => `<option value="${v}" ${v === valor ? "selected" : ""}>${r}</option>`).join("");
}

async function carregarSugestoesAdmin(statusFiltro = "") {
  const token = tokenAtual();
  if (!token) return null;
  const q = statusFiltro ? `?status=${encodeURIComponent(statusFiltro)}` : "";
  const r = await fetch(`${ROOT}/api/sugestoes/admin${q}`, {headers:{"Authorization":`Bearer ${token}`}});
  if (r.status === 403) return null;
  if (!r.ok) throw new Error("Não foi possível carregar as sugestões.");
  return await r.json() as SugestaoAdmin[];
}

async function abrirAdmin() {
  const backdrop = document.createElement("div");
  backdrop.className = "sugestao-backdrop";
  backdrop.innerHTML = `<div class="sugestao-modal sugestao-admin-modal" role="dialog" aria-modal="true" aria-label="Avaliar sugestões">
    <div class="sugestao-head"><div><h2>Avaliar sugestões</h2><p>Classifique as ideias recebidas e registre a decisão da equipe.</p></div><button class="sugestao-close" aria-label="Fechar">×</button></div>
    <div class="sugestao-admin-toolbar"><label for="sugestao-filtro">Status</label><select id="sugestao-filtro"><option value="">Todos</option>${statusSugestoes.map(([v,r])=>`<option value="${v}">${r}</option>`).join("")}</select></div>
    <div class="sugestao-status" hidden></div><div class="sugestao-admin-list"></div>
  </div>`;
  document.body.appendChild(backdrop);
  const fechar = () => backdrop.remove();
  backdrop.querySelector(".sugestao-close")?.addEventListener("click", fechar);
  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) fechar(); });
  const lista = backdrop.querySelector(".sugestao-admin-list") as HTMLDivElement;
  const aviso = backdrop.querySelector(".sugestao-status") as HTMLDivElement;
  const filtro = backdrop.querySelector("#sugestao-filtro") as HTMLSelectElement;

  const render = async () => {
    lista.innerHTML = "Carregando…";
    try {
      const itens = await carregarSugestoesAdmin(filtro.value);
      if (itens === null) { fechar(); return; }
      lista.innerHTML = itens.length ? itens.map((item) => `<article class="sugestao-admin-card" data-id="${item.id}">
        <div class="sugestao-admin-meta">#${item.id} · ${item.usuario_email} · ${item.pagina} · ${item.componente} · ${item.criado_em}</div>
        <div class="sugestao-admin-msg">${item.mensagem.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}</div>
        <div class="sugestao-admin-edit"><label>Status<select data-status>${opcoesStatus(item.status)}</select></label><label>Nota de avaliação<textarea data-nota maxlength="2000" placeholder="Motivo, decisão ou encaminhamento">${(item.nota_avaliacao || "").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}</textarea></label><button class="sugestao-admin-save" data-salvar>Salvar</button></div>
      </article>`).join("") : "Nenhuma sugestão encontrada.";
      lista.querySelectorAll<HTMLButtonElement>("[data-salvar]").forEach((botao) => botao.addEventListener("click", async () => {
        const card = botao.closest<HTMLElement>("[data-id]")!;
        const status = (card.querySelector("[data-status]") as HTMLSelectElement).value;
        const nota_avaliacao = (card.querySelector("[data-nota]") as HTMLTextAreaElement).value.trim();
        botao.disabled = true; botao.textContent = "Salvando…";
        try {
          const r = await fetch(`${ROOT}/api/sugestoes/admin/${card.dataset.id}`, {method:"PATCH",headers:{"Content-Type":"application/json","Authorization":`Bearer ${tokenAtual()}`},body:JSON.stringify({status,nota_avaliacao})});
          const body = await r.json().catch(() => ({}));
          if (!r.ok) throw new Error(body?.detail || "Falha ao atualizar sugestão.");
          aviso.hidden = false; aviso.className = "sugestao-status"; aviso.textContent = `Sugestão #${card.dataset.id} atualizada.`;
          botao.textContent = "Salvo";
        } catch (e:any) {
          aviso.hidden = false; aviso.className = "sugestao-status erro"; aviso.textContent = e?.message || "Falha ao atualizar sugestão.";
          botao.disabled = false; botao.textContent = "Salvar";
        }
      }));
    } catch (e:any) {
      lista.innerHTML = ""; aviso.hidden = false; aviso.className = "sugestao-status erro"; aviso.textContent = e?.message || "Falha ao carregar sugestões.";
    }
  };
  filtro.addEventListener("change", render);
  await render();
}

async function instalarAdminSePermitido() {
  if (document.querySelector(".sugestoes-admin-btn")) return;
  try {
    const itens = await carregarSugestoesAdmin();
    if (itens === null) return;
    const btn = document.createElement("button");
    btn.className = "sugestoes-admin-btn";
    btn.type = "button";
    btn.textContent = `Avaliar sugestões${itens.length ? ` (${itens.length})` : ""}`;
    btn.addEventListener("click", abrirAdmin);
    document.body.appendChild(btn);
  } catch { /* botão administrativo é opcional */ }
}

function instalar() {
  if (document.querySelector(".sugira-melhorias-btn")) return;
  instalarEstilos();
  const btn = document.createElement("button");
  btn.className = "sugira-melhorias-btn";
  btn.type = "button";
  btn.textContent = "Sugira melhorias";
  btn.addEventListener("click", abrirModal);
  document.body.appendChild(btn);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", instalar);
else instalar();
